module.exports = __webpack_public_path__ + "img/bb1f791.png";